// src/socket.js
import { io } from 'socket.io-client';

const SOCKET_URL = `http://localhost:5000`; // your BE URL
const SECRET_PATH = process.env.REACT_APP_SECRET_PATH || 'socket'; // match your BE path

let socket;

export const connectSocket = (userId, deviceInfo = {}) => {
  socket = io(SOCKET_URL, {
    path: `/${SECRET_PATH}`,
    transports: ['websocket'],
    withCredentials: true
  });

  socket.on('connect', () => {
    console.log('Socket connected: ', socket.id);
    socket.emit('registerUser', { userId, deviceInfo });
  });

  socket.on('disconnect', () => {
    console.log('Socket disconnected');
  });

  return socket;
};

export const getSocket = () => socket;
